import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonDateService {

  constructor() { }

  // Converting Monthly to quarterly data
  convertMonthlyToQuarterlyVolume(monthlyData, startMonthIdx, endMonthIdx) {
    var quarterlyData = [];
    for (let i = startMonthIdx; i < endMonthIdx + 1; i = i + 3) {
      if (startMonthIdx % 3 == 0 && endMonthIdx % 3 == 2) {
        quarterlyData.push(monthlyData[i] + monthlyData[i + 1] + monthlyData[i + 2]);
      }
      else if (startMonthIdx % 3 == 0 && endMonthIdx % 3 == 1) {
        quarterlyData.push(i == (endMonthIdx - 1) ? (monthlyData[i] + monthlyData[i + 1]) : (monthlyData[i] + monthlyData[i + 1] + monthlyData[i + 2]));
      }
      else if (startMonthIdx % 3 == 0 && endMonthIdx % 3 == 0) {
        quarterlyData.push(i == endMonthIdx ? monthlyData[i] : (monthlyData[i] + monthlyData[i + 1] + monthlyData[i + 2]));
      }
      else if (startMonthIdx % 3 == 1 && endMonthIdx % 3 == 2) {
        if (i == startMonthIdx) {
          quarterlyData.push(monthlyData[i] + monthlyData[i + 1]);
          i = i - 1;
        }
        else {
          quarterlyData.push(monthlyData[i] + monthlyData[i + 1] + monthlyData[i + 2]);
        }
      }
      else if (startMonthIdx % 3 == 1 && endMonthIdx % 3 == 1) {
        if (i == startMonthIdx) {
          quarterlyData.push(monthlyData[i] + monthlyData[i + 1]);
          i = i - 1;
        }
        else {
          quarterlyData.push(i == (endMonthIdx - 1) ? (monthlyData[i] + monthlyData[i + 1]) : (monthlyData[i] + monthlyData[i + 1] + monthlyData[i + 2]));
        }
      }
      else if (startMonthIdx % 3 == 1 && endMonthIdx % 3 == 0) {
        if (i == startMonthIdx) {
          quarterlyData.push(monthlyData[i] + monthlyData[i + 1]);
          i = i - 1;
        }
        else {
          quarterlyData.push(i == endMonthIdx ? monthlyData[i] : (monthlyData[i] + monthlyData[i + 1] + monthlyData[i + 2]));
        }
      }
      else if (startMonthIdx % 3 == 2 && endMonthIdx % 3 == 2) {
        if (i == startMonthIdx) {
          quarterlyData.push(monthlyData[i]);
          i = i - 2;
        }
        else {
          quarterlyData.push(monthlyData[i] + monthlyData[i + 1] + monthlyData[i + 2]);
        }
      }
      else if (startMonthIdx % 3 == 2 && endMonthIdx % 3 == 1) {
        if (i == startMonthIdx) {
          quarterlyData.push(monthlyData[i]);
          i = i - 2;
        }
        else {
          quarterlyData.push(i == (endMonthIdx - 1) ? (monthlyData[i] + monthlyData[i + 1]) : (monthlyData[i] + monthlyData[i + 1] + monthlyData[i + 2]));
        }
      }
      else if (startMonthIdx % 3 == 2 && endMonthIdx % 3 == 0) {
        if (i == startMonthIdx) {
          quarterlyData.push(monthlyData[i]);
          i = i - 2;
        }
        else {
          quarterlyData.push(i == endMonthIdx ? monthlyData[i] : (monthlyData[i] + monthlyData[i + 1] + monthlyData[i + 2]));
        }
      }
    }
    return quarterlyData;
  }

  //This function will calculate start month index and end month index of contract period
  calculateStartMonthIndexOfContractPeriod(dates) {
    var startMonthIdx = 0;
    for (let i = 0; i < dates.length; i++) {
      if (dates[i].Contract == 1) {
        startMonthIdx = i;
        break;
      }
    }
    return startMonthIdx;
  }

  getMonthNameByIndex(idx) {
    var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return monthNames[idx - 1];
  }

  // calculateEndMonthIndexOfContractPeriod(dates) {
  //   var endMonthIdx = 0;
  //   for (let i = startMonthIdx; i < dates.length; i++) {
  //     if (dates[i + 1] == undefined || dates[i + 1].Contract == 0) {
  //       endMonthIdx = i;
  //       break;
  //     }
  //   }
  //   return endMonthIdx;
  // }

  //This function will convert monthly data to calendar yearly data depending on the contract period selected
  // convertMonthlyToYearlyVolume(startMonthIdx, endMonthIdx, monthlyData, dates) {
  //   var tempstartMonthIdx = startMonthIdx;
  //   var tempSum = 0;
  //   var yearly = [];
  //   for (i = startMonthIdx; i < endMonthIdx + 1; i++) {
  //     if (dates[tempstartMonthIdx].Year == dates[i].Year) {
  //       tempSum += monthlyData[i];
  //     }
  //     else {
  //       yearly.push(tempSum);
  //       tempstartMonthIdx = i;
  //       tempSum = 0;
  //       tempSum += monthlyData[i];
  //     }
  //   }
  //   yearly.push(tempSum);
  //   return yearly;
  // }

  // This function will convert monthly data to contract yearly data depending on the contract period selected
  // convertMonthlyToContractYearlyVolume(startMonthIdx, endMonthIdx, monthlyData) {
  //   var monthCount = 0;
  //   tempSum = 0;
  //   var contractYearly = [];
  //   for (i = startMonthIdx; i < endMonthIdx + 1; i++) {
  //     if (monthCount < 12) {
  //       monthCount += 1;
  //       tempSum += monthlyData[i];
  //     }
  //     else {
  //       contractYearly.push(tempSum);
  //       tempSum = 0;
  //       tempSum += monthlyData[i];
  //       monthCount = 1;
  //     }
  //   }
  //   contractYearly.push(tempSum);
  //   return contractYearly;
  // }

  calculateCummulativeROC(numerator, denominator) {
    var cummulativeNumerator = 0;
    var cummulativeDenominator = 0;
    var ROC = [];
    for (let j = 0; j < numerator.length; j++) {
      cummulativeNumerator += numerator[j];
      cummulativeDenominator += denominator[j];
      var tempROC = (cummulativeDenominator != 0 ? (cummulativeNumerator / cummulativeDenominator) : 0);
      ROC.push(tempROC);
    }
    return ROC;
  }

  getDateTimeForRangePickerFromTimeSpec(timeSpec, ContractStartDate, ContractEndDate) {

    // Only consider range up to last entry where Graph is 0
    var calendarRangeStart: string;
var calendarRangeEnd: string;

    // Check if Graph property exists
    if (timeSpec[0]?.Graph !== undefined) {
      const lastGraphZeroIdx = timeSpec.map(d => d.Graph).lastIndexOf(0);
      const filteredTimeSpec = timeSpec.slice(0, lastGraphZeroIdx + 1);

      calendarRangeStart = ('0' + (filteredTimeSpec[0].Month)).slice(-2) + "-" + filteredTimeSpec[0].Year;
      calendarRangeEnd = ('0' + (filteredTimeSpec[filteredTimeSpec.length - 1].Month)).slice(-2) + "-" + filteredTimeSpec[filteredTimeSpec.length - 1].Year;
    } else {
      calendarRangeStart = ('0' + (timeSpec[0].Month)).slice(-2) + "-" + timeSpec[0].Year;
      calendarRangeEnd = ('0' + (timeSpec[timeSpec.length - 1].Month)).slice(-2) + "-" + timeSpec[timeSpec.length - 1].Year;
    }
    var contractStart = ('0' + (ContractStartDate.getMonth() + 1)).slice(-2) + "-" + ContractStartDate.getFullYear();
    var contractEnd = ('0' + (ContractEndDate.getMonth() + 1)).slice(-2) + "-" + ContractEndDate.getFullYear();

    var dateRange = {
      minRange: calendarRangeStart,
      maxRange: calendarRangeEnd,
      startRange: contractStart,
      endRange: contractEnd
    }

    return dateRange;
  }

  getContractStartEndInDateFormat(conractStartMonthYear, contractEndMonthYear) {

    var startDate = conractStartMonthYear.split('-');
    var endDate = contractEndMonthYear.split('-');
    var start = new Date(startDate[1], (startDate[0] - 1));
    var end = new Date(endDate[1], (endDate[0] - 1));
    end.setMonth(end.getMonth() + 1);
    end.setDate(end.getDate() - 1);

    let contractPeriod = {
      ContractStartDate: start,
      ContractEndDate: end
    }

    return contractPeriod;
  }


  calculateTimeSpec(baselineMonthIndex, originalDates) {
    var dates = JSON.parse(JSON.stringify(originalDates));
    if (baselineMonthIndex >=0 && baselineMonthIndex < 5) {
      baselineMonthIndex = 5;
    }
    for (var mon = 0; mon < dates.length; mon++) {
      if (mon < baselineMonthIndex) {
        dates[mon].Historical = 1;
        dates[mon].Forecast = 0;
        dates[mon].Baseline = 0;
      }
      else if (mon == baselineMonthIndex) {
        dates[mon].Historical = 1;
        dates[mon].Forecast = 0;
        dates[mon].Baseline = 1;
        dates[mon - 1].Baseline = 1;
        dates[mon - 2].Baseline = 1;
      }
      else if(baselineMonthIndex == -1){
        //keep the same array
      }
      else {
        dates[mon].Historical = 0;
        dates[mon].Forecast = 1;
        dates[mon].Baseline = 0;
      }
    }

    return dates;
  }

  //it will return a concatinated string of baseline year and months eg:',201908,201909,201910'
  getBaslineYearMonths(timeSpec) {

    let baselineYearMonths = '';
    let count = 0;
    for (let dateIdx = 0; dateIdx < timeSpec.length; dateIdx++) {
      if (timeSpec[dateIdx].Baseline == '1') {
        baselineYearMonths += ',' + timeSpec[dateIdx].Year + (timeSpec[dateIdx].Month < 10 ? '0' + timeSpec[dateIdx].Month : timeSpec[dateIdx].Month);
        count += 1;
      }
      if (count == 3) {
        baselineYearMonths = baselineYearMonths + ',';
        break;
      }

    }
    return baselineYearMonths;
  }

  getHistoricalYearMonths(timeSpec) {

    let baselineYearMonths = '';
    let count = 0;
    for (let dateIdx = 0; dateIdx < timeSpec.length; dateIdx++) {
      if (timeSpec[dateIdx].Historical == '1') {
        baselineYearMonths += ',' + timeSpec[dateIdx].Year + (timeSpec[dateIdx].Month < 10 ? '0' + timeSpec[dateIdx].Month : timeSpec[dateIdx].Month);
        count += 1;
      }

    }
    baselineYearMonths = baselineYearMonths + ',';
    return baselineYearMonths;
  }

  dateFormat = function (date) {
    var format = "y-m-d";
    var separator = "/";
    var date1 = new Date(date);
    var day = date1.getDate();
    var month = date1.getMonth() + 1;
    var year = date1.getFullYear();
    var dateObject = {
      d: day,
      m: month,
      y: year
    };
    var formatArr = format.split("-");
    return dateObject[formatArr[0]] + separator + dateObject[formatArr[1]] + separator + dateObject[formatArr[2]];
  }

  loadQuarterDates = function (timeData) {
    var quarterDates = [];

    for (var k = 0; k < timeData.length; k = k + 3) {
      var quarterDate = {
        qtr: timeData[k].qtr,
        Year: timeData[k].Year,
        Historical: timeData[k].Historical,
        Forecast: timeData[k].Forecast,
        Contract: timeData[k].Contract,
        Graph: timeData[k].Graph,
        Partial: 0
      };

      if (timeData[k].Historical !== timeData[k + 1].Historical ||
        timeData[k + 1].Historical !== timeData[k + 2].Historical) {
        quarterDate.Partial = 1;
      }
      quarterDates.push(quarterDate);
    }
    return quarterDates;
  }

  /**
   * Filter quarters based on screen type
   * Database setup:
   * - Regular quarters: Forecast=1, Graph=0
   * - Extended +2 years for indirect cost: Forecast=1, Graph=1
   * 
   * Usage:
   * - baseline/contract details/inputs: Filter out Graph=1 (hide extended periods)
   * - contract financials/indirect cost: Show all quarters (include Graph=1)
   */
  getQuartersForScreen(quarters: any[], screenType: 'baseline' | 'financials' | 'inputs'): any[] {
    if (!quarters || quarters.length === 0) return [];
    
    switch(screenType) {
      case 'baseline':
      case 'inputs':
        // Hide extended forecast periods (Graph=1) from baseline/input screens
        return quarters.filter(q => q.Graph !== 1);
      
      case 'financials':
        // Show all quarters including extended forecast (Graph=0 and Graph=1)
        return quarters;
      
      default:
        return quarters;
    }
  }
}
